import StorageHeading from './StorageHeading';
export default StorageHeading;
